import {createContext} from "react";
import {IProfileState} from "./IProfileState";
export const initState: IProfileState = {
  // isAuth: getAuthData() !== null,
  profile: null,
  // authData: getAuthData(),
  setProfile: () => {}
}

export const ProfileContext = createContext(initState)

